/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditBaseRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditBaseRequest>): RequestAuditBaseRequest {
        let obj = Object.assign(new RequestAuditBaseRequest(), model);
        RequestAuditBaseRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditBaseRequest>): RequestAuditBaseRequest {
        if (!model) return null;
        return RequestAuditBaseRequest.newInstance(<RequestAuditBaseRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditBaseRequest) {
        if (!obj) return;

        models.RequestAuditBaseRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditBaseRequest): boolean {
        Object.setPrototypeOf(obj, RequestAuditBaseRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Target executor
     */
    executor: models.BackgroundJobExecutor;

}
